import request from "@/utils/server.js";

// 查询活动列表
export function getActiveListAPI(data) {
  return request({
    url: "/active/list",
    method: "get",
    params: data,
  });
}

// 新增活动列表
export function addActiveAPI(data) {
  return request({
    url: "/active/add",
    method: "post",
    data,
  });
}

// 修改活动列表
export function updateActiveAPI(data) {
  return request({
    url: "/active/update",
    method: "put",
    data,
  });
}

// 删除活动列表
export function deleteActiveAPI(data) {
  return request({
    url: `/active/delete/${data.activeId}`,
    method: "delete",
  });
}
